import type { IResponseBase } from '@/interfaces';
import type {
	ICreateExonerationRecommendation,
	IExonerationRecommendation,
} from '@/interfaces/IExonerationRecommendation';
import { Http, HttpService } from './http';

const http = Http.create();

/**
 * Endpoints de recomendação de exoneração (feature ENG-331).
 * Todos exigem a role ADMIN no backend.
 */
export class ExonerationRecommendationService extends HttpService {
	static async listByCase(caseId: string) {
		const response = await http.get<IResponseBase<IExonerationRecommendation[]>>(
			`/ExonerationRecommendations/by-case/${caseId}`,
		);
		return response.data.data;
	}

	static async create(payload: ICreateExonerationRecommendation) {
		const response = await http.post<IResponseBase<IExonerationRecommendation>>(
			`/ExonerationRecommendations`,
			payload,
		);
		return response.data.data;
	}

	static async remove(id: string) {
		await http.delete(`/ExonerationRecommendations/${id}`);
	}
}

export default ExonerationRecommendationService;
